export default "__VITE_ASSET__2a6f120f__"